import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Box } from '@wix/design-system';
import { Tool } from './Tool';
import PrivacyTool from '../../assets/images/PrivacyTool_optimized.svg';
import SSLTool from '../../assets/images/SSLTool_optimized.svg';
import BusinessEmailTool from '../../assets/images/BusinessEmailTool_optimized.svg';
import { useIsMobile } from '@wix/core-domain-search';
export const MoreTools = () => {
  const isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    paddingTop: "SP10"
  }, MORE_TOOLS.map((tool, index) => /*#__PURE__*/React.createElement(Tool, _extends({
    key: tool.titleKey
  }, tool, {
    index: index,
    isMobile: isMobile
  }))));
};
export const MORE_TOOLS = [{
  titleKey: 'domain_search_gate.domain_gate.add_ons_section.privacy.header',
  descriptionKey: 'domain_search_gate.domain_gate.add_ons_section.privacy.body',
  backgroundColor: '#D1F0B1',
  illustration: /*#__PURE__*/React.createElement(PrivacyTool, null)
}, {
  titleKey: 'domain_search_gate.domain_gate.add_ons_section.ssl.header',
  descriptionKey: 'domain_search_gate.domain_gate.add_ons_section.ssl.body',
  backgroundColor: '#1E56C3',
  light: true,
  illustration: /*#__PURE__*/React.createElement(SSLTool, null)
}, {
  titleKey: 'domain_search_gate.domain_gate.add_ons_section.business_email.header',
  descriptionKey: 'domain_search_gate.domain_gate.add_ons_section.business_email.body',
  backgroundColor: '#E2D8FF',
  illustration: /*#__PURE__*/React.createElement(BusinessEmailTool, null)
}];
//# sourceMappingURL=MoreTools.js.map